import { render, staticRenderFns } from "./EmployeeModalForm.vue?vue&type=template&id=15162836"
import script from "./EmployeeModalForm.vue?vue&type=script&lang=js"
export * from "./EmployeeModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports